import React, { useState } from "react";
import styled from "styled-components";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import Permission from "../../../components/Common/Permission";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { isObjectStateEmpty } from "../../../utils";

const InputBar = (props) => {
  const { handleSubmit, permissions } = props;
  const [inputStates, setInputStates] = useState({
    driver_id: "",
    phone_no: "",
  });
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ASSETS];
  const handleChange = (key, val) => {
    const values = { ...inputStates };
    values[key] = val;
    setInputStates(values);
  };
  const handleFormSubmit = () => {
    handleSubmit(inputStates);
  };
  const checkIfButtonDisabled = () => {
    return isObjectStateEmpty(inputStates);
  };
  return (
    <AssetsInputBar className="flex items-center justify-between">
      <Input
        value={inputStates["driver_id"]}
        data-testid="driverId"
        id="sushi-input"
        onChange={(e) => handleChange("driver_id", e)}
        label="Driver FE ID"
      />
      <span className="bold mr-10">OR</span>
      <Input
        value={inputStates["phone_no"]}
        type="number"
        id="sushi-input"
        data-testid="phone-no"
        onChange={(e) => handleChange("phone_no", e)}
        label="Phone No"
      />
      <Permission
        requiredPerms={permissions ? permissions : [allActions.ISSUANCE_LIST]}
      >
        <Button
          data-testid="submitButton"
          className="sushi-btn mb-10"
          onClick={handleFormSubmit}
          disabled={checkIfButtonDisabled()}
        >
          Apply
        </Button>
      </Permission>
    </AssetsInputBar>
  );
};

const AssetsInputBar = styled.div`
  max-width: 530px;
  margin-right: 0;
  margin-left: auto;
  margin-bottom: 40px;
  #sushi-input {
    margin-bottom: unset;
  }
  #sushi-input > div {
    display: none;
  }
`;

export default InputBar;
